/*
提供一些方法，在嵌入模式下，访问父页面
*/
import { computed, observable, autorun } from "mobx"
import * as queryString from "utils/queryString";
import * as base64 from "utils/base64";

import { ClientType } from "./type";
import { createHostContext, IClientHostContext } from "./hosts";
import { parse, stringify, defaultOptions, IClientHostOptions } from "./options";
import Browser from "utils/browser";
const url = location.href;
const queryParams = queryString.parse(url, true);
let options: IClientHostOptions = null;

if (queryParams.token) {
    options = parse(queryParams.token);
} else {
    var matchs = location.pathname.match(/^\/facebook\/(\d+)/);
    if (matchs && queryParams.from=="facebook") {
        var token = stringify({
            frameId: "fb-tab",
            preview: queryParams.preview,
            type: "facebook",
            autoHeight: true,
            use_scrollbar: false,
            facebook: {
                page_id: matchs[1]
            }
        });
        options = parse(token);
    } else {
        options = defaultOptions;
    }
}

export class SparxoClientHost {
    options: IClientHostOptions = options;
    context: IClientHostContext;
    browser = Browser;

    getClassList() {
       
    }

    classList = observable.array([]);

    constructor(public app) {
        if (!this.options.type) {
            this.options.type = app;
        }
        if (this.browser.isFBIOS()) {
            this.options.use_scrollbar = false;
        }
        this.context = createHostContext({ app, ...this.options });
        window["clientHost"] = this.context;
        this.initClass();
        autorun(() => {
            var cls = this.classList;
            document.documentElement.className = cls.join(" ");
        });
    }

    initClass() {
        const browserCls = this.browser.getClassList();
        const typeClass = {
            [ClientType.normal]: ["sp-mode-normal"],
            [ClientType.embed]: ["sp-mode-embed"],
            [ClientType.splash]: ["sp-mode-splash"],
            [ClientType.mobile]: ["sp-mode-mobile"]
        }
        const optionClass = [];
        if (this.options.modal) {
            optionClass.push("sp-in-modal");
        }
        if (this.options.autoHeight) {
            document.documentElement.style.overflow = "hidden";
            optionClass.push("auto-fill");
        }
        var contextClass = this.context.classList;
        this.classList.push(
            ...browserCls,
            ...typeClass[this.options.type],
            ...optionClass,
            ...contextClass
        )

    }

    previewPhotos(idx, images) {
        this.context.previewPhotos && this.context.previewPhotos(idx, images);
    }
    showEventModal(id,code?) {
        this.context.showEventModal && this.context.showEventModal(id,code);
    }
    setModalSize({ width, height }) {
        this.context.setModalSize && this.context.setModalSize({ width, height });
    }

    close() {
        if (queryParams.__fb_ref__) {
            location.href = queryParams.__fb_ref__;
            return;
        }
        this.context.close && this.context.close();
    }

    autoFill() {

    }

    resizeTo({ width, height }) {
        this.context.resizeTo && this.context.resizeTo({ width, height });
    }

    scrollTo({ x, y }) {
        this.context.scrollTo && this.context.scrollTo({ x, y });
    }

    scrollToElement(selector,offset) {
        this.context.scrollToElement && this.context.scrollToElement(selector, offset);        
    }

    focusInvalidInput() {

    }
}


// WEBPACK FOOTER //
// ./src/Apps/shared/ClientHost/index.ts